/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialogue_List_Export_General_OptionsInputs */



/**
* | output |
* | --- |
* | "General Options" |
*
* @param {Dialogue_List_Export_General_OptionsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const dialogue_list_export_general_options = /** @type {((inputs?: Dialogue_List_Export_General_OptionsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialogue_List_Export_General_OptionsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options générales")
	if (locale === "de") return /** @type {LocalizedString} */ ("Allgemeine Optionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni generali")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Общие параметры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones generales")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("一般选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一般オプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आम विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções gerais")
	return /** @type {LocalizedString} */ ("General Options")
});